import axios from 'axios'

class CommentService {
	url
	db_name
	user_id
	user_token

	constructor() {
		this.url = base_url + 'journal/comment'
		this.db_name = client_db_name
		this.user_id = current_user_id
		this.user_token = current_user_token
	}

	async create(data) {
		const response = await axios.post(`${this.url}`, data, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async update(id, data) {
		try {
			const response = await axios.put(`${this.url}/${id}`, data, {
				params: {
					db_name: this.db_name,
					user_id: this.user_id,
					user_token: this.user_token,
				},
			});
			return response;
		} catch (error) {
			console.log(error.response.data.message);
		}
	}

	async getAll(filters) {
		const params = {
			db_name: this.db_name,
			user_id: this.user_id,
			user_token: this.user_token,
			...filters
		}
		const response = await axios.get(`${this.url}`, {
			params
		});
		return response;
	}

	async get(id) {
		const response = await axios.get(`${this.url}/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}
}

export default CommentService
